import ApprovalHistory from '@/models/ApprovalHistory/ApprovalHistory';

export default class ApprovalHistoryFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.approvalInstanceId  = '';
		this.approvalInstanceApprovalTag = '';
		this.approverTypeId  = '';
		this.approverTypeName = '';
		this.approvalStructureId  = '';
		this.approvalStructureName = '';
		this.approverLevel = '';
		this.approverUserName = '';
		this.sequence = '';
		this.acitivtyStateId  = '';
		this.acitivtyStateName = '';
		this.approvalConfigurationInstanceDetailId  = '';
		this.approvalConfigurationInstanceDetailApproverType = '';
		this.message = '';
		this.status = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			approvalInstanceId : '0',
			approvalInstanceApprovalTag : '0',
			approverTypeId : '0',
			approverTypeName : '0',
			approvalStructureId : '0',
			approvalStructureName : '0',
			approverLevel : '0',
			approverUserName : '0',
			sequence : '0',
			acitivtyStateId : '0',
			acitivtyStateName : '0',
			approvalConfigurationInstanceDetailId : '0',
			approvalConfigurationInstanceDetailApproverType : '0',
			message : '0',
			status : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}